import { MapPin, Wrench, CalendarDays, FileText } from "lucide-react";

const FEATURES = [
  { icon: MapPin, title: "Plot activity", body: "Every planting, irrigation cycle and harvest, timestamped and traceable." },
  { icon: FileText, title: "Documents", body: "Deeds, agreements and receipts — one folder per plot, always at hand." },
  { icon: Wrench, title: "Maintenance", body: "Assign, block, resolve. State machine with an audit trail on every task." },
  { icon: CalendarDays, title: "Cottage bookings", body: "Owner calendar with conflict detection and maintenance blackout dates." },
];

export function FeaturesSection() {
  return (
    <section className="border-t border-border grain-bg">
      <div className="max-w-6xl mx-auto px-6 py-16 grid md:grid-cols-4 gap-6">
        {FEATURES.map((f) => (
          <div key={f.title}
               className="p-6 rounded-lg border border-border bg-card transition-[transform,box-shadow] duration-200 hover:-translate-y-0.5 hover:shadow-sm"
               data-testid={`feature-${f.title.toLowerCase().replace(/\s+/g, "-")}`}>
            <f.icon size={22} className="text-primary" />
            <div className="heading text-xl font-semibold mt-4">{f.title}</div>
            <p className="text-sm text-muted-foreground mt-2 leading-relaxed">{f.body}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
